import { APP } from 'src/Configs/App'
import { campaignsList, login } from 'src/Router/routes'
import {
  buildSourceBusterPayload,
  collectDataFromSourceBuster,
} from 'src/Redux/sourcebuster-process/api-actions'
import { getClientId, getGaSession } from 'src/Redux/analyticsApi/helpers'

import { persistPendingSpotifyCuratorAuth } from './pendingSpotifyCuratorAuth'

export interface InitiateSpotifyAuthParams {
  isSignUp?: boolean
}

const extractFbclid = (landingPage: string): string => {
  const match = landingPage?.match(/[?&]fbclid=([^&]+)/)
  return match ? match[1] : ''
}

const collectAnalyticsParams = (): Record<string, string> => {
  const sbData = collectDataFromSourceBuster()
  const sbPayload = buildSourceBusterPayload(sbData, '')

  const fbclid =
    extractFbclid(sbPayload.lastLandingPage) ||
    extractFbclid(sbPayload.firstLandingPage)

  const result: Record<string, string> = {}
  const add = (key: string, value: string | undefined): void => {
    if (value) {
      result[key] = value
    }
  }

  add('utmSource', sbPayload.lastUtmSource)
  add('utmMedium', sbPayload.lastUtmMedium)
  add('utmCampaign', sbPayload.lastUtmCampaign)
  add('utmContent', sbPayload.lastUtmContent)
  add('utmTerm', sbPayload.lastUtmTerm)
  add('gclid', sbPayload.gclid)
  add('fbclid', fbclid)
  add('referrerUrl', sbPayload.lastLandingPage)
  add('clientId', getClientId())
  add('gaSession', getGaSession())

  return result
}

export const initiateSpotifyAuth = ({
  isSignUp = false,
}: InitiateSpotifyAuthParams = {}): void => {
  if (isSignUp) {
    persistPendingSpotifyCuratorAuth()
  }

  const successUrl = `${window.location.origin}${campaignsList}`
  const cancelUrl = `${window.location.origin}${login}`
  const analyticsParams = collectAnalyticsParams()
  const params = new URLSearchParams({
    successUrl,
    cancelUrl,
    ...analyticsParams,
  })

  window.location.href = `${APP.TIKTOK_SERVER}/public/auth/spotify?${params.toString()}`
}
